export default __webpack_public_path__ + "static/media/blog-paver-walkway-007.9d6eac9b.jpg";